
import { Avatar, Container, InputBase, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import HeaderSession from '../utils/headerSession'
import RegisterAccess from '../utils/registerAccess'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import api from '../services/api'
import Paginacao from '../utils/paginacao'
import { useNavigate } from 'react-router-dom'

import TabelaLoading from '../load/tabelaLoading'
// import ProvinciaFilter from '../filters/provinciaFilter'

export default function InspectoreslistaPublica() {
    const navigate = useNavigate();
    const [inspectores, setInspectores] = useState(useSelector(state => state?.inspectorLicenciados?.data) ?? '')
    const [configLista, setConfigLista] = useState(useSelector(state => state?.inspectorLicenciados?.config) ?? '')
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(50)
    const [order, setOrder] = useState('DESC')
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('')
    const baseUrl = window.location.origin;


    useEffect(() => {
        setLoading(true)
        setInspectores('')

        api.get(`/admins?funcao=Inspector&perPage=${perPage}&status=Activo&page=${page}`)
            .then(response => {
                setInspectores(response.data.Admins)
                setConfigLista(response.data);
                setFilter(response.data.Admins);
            }).catch(err => { }).
            finally(() => { setLoading(false) })

    }, [page, perPage, order,]);

    // FILTRO DE Inspector
    const filtraInspector = (valor) => {
        setInspectores(filter.filter((inspector) => (inspector?.dadosPessoais?.nome?.toLowerCase().includes(valor.toLowerCase()) || inspector?.dadosPessoais?.provincia?.toLowerCase().includes(valor.toLowerCase()) || inspector?.dadosPessoais?.numeroAgente?.toLowerCase().includes(valor.toLowerCase()))))
    }



    return (
        <Container style={{ minHeight: '70vh', minWidth: '90vw' }}>
            <RegisterAccess page={'Inspectores Licenciados'} />
            <HeaderSession
                title={`LISTA PÚBLICA DE INSPECTORES`}
            />

            <InputBase
                style={{ width: '100%', border: '1px solid #85287e', borderRadius: 5, paddingLeft: 20, marginBottom: 10 }}
                // sx={{ ml: 1, flex: 1 }}
                autoFocus
                placeholder="Filtro"
                inputProps={{ 'aria-label': 'Filtrar lista' }}
                onChange={(e) => { filtraInspector(e.target.value) }}
            />

            {inspectores &&

                <TableContainer sx={{ border: "1px black" }} component={Paper}>
                    <Table sx={{ border: "1px", borderColor: "black" }}>
                        <TableHead sx={{ backgroundColor: "#dcdede" }}>
                            <TableRow>
                                {/* <TableCell ><Typography noWrap> <strong>Foto</strong></Typography></TableCell> */}
                                {/* <TableCell ><Typography noWrap> <strong>Funçã</strong></Typography></TableCell> */}
                                <TableCell ><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                                {/* <TableCell ><Typography noWrap> <strong>Secção</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Departamento</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Nº de Agente</strong></Typography></TableCell> */}
                                <TableCell ><Typography noWrap> <strong>Provincia</strong></Typography></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {inspectores.map((inspector) => (
                                <TableRow key={inspector._id} title={inspector?.dadosPessoais?.nome}>
                                    {/* onClick={() => navigate(`/verifica-tecnico/${inspector?._id}`)}  */}

                                    {/* <TableCell component="th" scope="row">
                                        <Avatar variant='square' src={inspector?.dadosPessoais.fotoURL} alt={inspector?.dadosPessoais.nome} />
                                    </TableCell> */}

                                    {/* <TableCell >{inspector?.funcao}</TableCell> */}
                                    <TableCell >{inspector?.dadosPessoais?.nome}</TableCell>
                                    {/* <TableCell >{inspector?.seccao}</TableCell> */}
                                    {/* <TableCell >{inspector?.departamento}</TableCell> */}
                                    {/* <TableCell >{inspector?.numeroAgente}</TableCell> */}
                                    <TableCell >{inspector?.dadosPessoais?.provincia}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Paginacao
                        configLista={configLista}
                        lista={inspectores}
                        page={page}
                        setPage={setPage}
                        setPerPage={setPerPage}
                        setOrder={setOrder}
                    // exportarExcel={exportarExcel}
                    />

                </TableContainer>
            }

            {loading && <TabelaLoading text={'Lista Actualizada de inspectores Farmacêuticos Autorizados.'} />}

        </Container>
    )
}
